import { Button } from '@giphy/react-giphy-brand'
import React from 'react'
import styled from 'styled-components'

type Props = {
    displayName: string
    onClick: () => void
}

const ButtonPositioned = styled(Button)`
    /* not responsive, button will be too big */
    display: flex;
    justify-content: center;
    /* I hate line height, override it here so things line up with different font-styles */
    line-height: inherit;
    font-family: 'interface', Helvetica Neue, helvetica, sans-serif;
`

const Name = styled.div`
    font-style: italic;
    font-weight: normal;
    margin-left: 3px;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
`

const AddToButton = ({ displayName, onClick }: Props) =>
    displayName ? (
        <ButtonPositioned onClick={onClick}>
            Add to
            <Name>{displayName}</Name>
        </ButtonPositioned>
    ) : null

export default AddToButton
